var map = {
	"./bgme-shop/Antique Oak.jpg": "ea87",
	"./bgme-shop/Basic.jpg": "054f",
	"./bgme-shop/Blue Canvas.jpg": "e678",
	"./bgme-shop/Blue Marble.jpg": "1cbe",
	"./bgme-shop/Candy Flavored.jpg": "37a9",
	"./bgme-shop/Emerald.jpg": "8970",
	"./bgme-shop/Faux Wood.jpg": "b897",
	"./bgme-shop/Gold Standard.jpg": "1dc3",
	"./bgme-shop/Green Plastic.jpg": "f4c4",
	"./bgme-shop/Industrial Strength.jpg": "3958",
	"./bgme-shop/Metal.jpg": "a07b",
	"./bgme-shop/Modern Maple.jpg": "b47b",
	"./bgme-shop/Neo.jpg": "3c0e",
	"./bgme-shop/Newspaper.jpg": "cb8d",
	"./bgme-shop/Pink Standard.jpg": "3563",
	"./bgme-shop/Simple Brown.jpg": "dd2f",
	"./bgme-shop/Simple Green.jpg": "485e",
	"./bgme-shop/Simple Purple.jpg": "1db7",
	"./bgme-shop/Simple Yellow.jpg": "ab10",
	"./bgme-shop/Textured Lavender.jpg": "b817",
	"./cah-shop/00s_pack.png": "469f",
	"./cah-shop/90sn_pack.png": "2cbe",
	"./cah-shop/Card Pack Set.png": "6828",
	"./cah-shop/Card Pack.png": "4f0b",
	"./cah-shop/abbb_pack.png": "19b0",
	"./cah-shop/abs_pack.png": "fa22",
	"./cah-shop/ace-of-spades-display.png": "4342",
	"./cah-shop/ai_pack.png": "9d5b",
	"./cah-shop/fant_pack.png": "2521",
	"./cah-shop/food_pack.png": "3718",
	"./cah-shop/glow_pack.png": "eb0e",
	"./cah-shop/golden-ticket-display.png": "030f",
	"./cah-shop/hum_pack.png": "a805",
	"./cah-shop/island-display.png": "d4cc",
	"./cah-shop/mona-lisa-display.png": "fa9f",
	"./cah-shop/prd_pack.png": "2bc7",
	"./cah-shop/pride-display.png": "88d2",
	"./cah-shop/starry-night-display.png": "3fbe",
	"./cah-shop/unicorn-display.png": "9b4c",
	"./cah-shop/weed_pack.png": "a9a2",
	"./cah-shop/white-card-display.png": "6e26",
	"./cah-shop/www_pack.png": "3bb9",
	"./che-shop/alpha.png": "00ea",
	"./che-shop/california.png": "ca22",
	"./che-shop/cardinal.png": "ee7a",
	"./che-shop/chess7.png": "566e",
	"./che-shop/chessnut.png": "4f5f7",
	"./che-shop/companion.png": "36b4",
	"./che-shop/dubrovny.png": "f917",
	"./che-shop/fantasy.png": "1b24",
	"./che-shop/fresca.png": "25d1",
	"./che-shop/gioco.png": "0698",
	"./che-shop/governor.png": "1b10",
	"./che-shop/icpieces.png": "4927",
	"./che-shop/kosal.png": "2fb2",
	"./che-shop/leipzig.png": "c45b",
	"./che-shop/letter.png": "9375",
	"./che-shop/maestro.png": "54c3",
	"./che-shop/merida.png": "0b67",
	"./che-shop/pirouetti.png": "97c8",
	"./che-shop/pixel.png": "1063",
	"./che-shop/riohacha.png": "390b",
	"./che-shop/shapes.png": "5d56",
	"./che-shop/spatial.png": "2697",
	"./che-shop/staunty.png": "1d40",
	"./che-shop/tatiana.png": "b343"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0e6";